import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import classNames from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'

import { useSafeArea } from '@/Providers/safe-area-provider'
import { sendEventLog } from '@/features/log/log.fn'

import * as styles from './header.css'

type AdsTheme = {
  bgImage: string
  stepsInfoBgColor: string
  headerFontColor: string
  overFlowBgColor: string
}

interface Props {
  title?: string
  content?: React.ReactNode
  noBorder?: boolean
  log?: {
    actionId?: string
    custom?: any
    pageid?: string
  }
  adsTheme?: AdsTheme
  allTargetingConditionsPassed?: boolean
}

export function Header(props: Props) {
  const { title, content, noBorder, log, adsTheme, allTargetingConditionsPassed } = props
  const [isTop, setIsTop] = useState(true)
  const { insetTop } = useSafeArea()

  const handleOnClick = useCallback(() => {
    if (log && log.pageid) {
      sendEventLog('tap.back', {}, log.pageid)
    }
    TmapApp.onBackKeyPressed()
  }, [log])

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        setIsTop(false)
      } else {
        setIsTop(true)
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      data-themed={adsTheme && allTargetingConditionsPassed ? 'theme' : 'default'}
      data-top={isTop ? 'true' : 'false'}
      className={classNames(styles.header, !isTop && !noBorder ? styles.headerScrollVariants.isScrolled : '')}
      style={{
        '--inset-top': `${insetTop}px`,
        '--header-font':
          adsTheme && allTargetingConditionsPassed
            ? adsTheme?.headerFontColor || '#171819'
            : '#171819',
      }}
    >
      <button
        className={styles.backBtn}
        type={'button'}
        onClick={handleOnClick}
      >
        이전 페이지
      </button>
      {title && <h1 className={styles.title}>{title}</h1>}
      {content && <>{content}</>}
    </header>
  )
}
